import { Box } from "@mui/material";
import React from "react";
import WithLove from "../../common/components/WithLove";
import Topic from "../../common/components/Topic";
import Picture from "../../common/components/Picture";
import Title from "../../common/components/Title";
import Content from "../../common/components/Content";
import Subtitle from "../../common/components/Subtitle";
import Text from "../../common/components/Text";
import SubSection from "../../common/components/SubSection";
import Section from "../../common/components/Section";
import Italics from "../../common/components/Italics";

// Images Import
// import cover from "../../images/6.0/day2/Cover Image.jpg";

import cover from "../../images/5.0/day2/0. Introduction.png";
import jesus from "../../images/5.0/day2/2. Jesus.png";
import will from "../../images/5.0/day2/3. Will-of-the-Lord.png";
import understandingChrist from "../../images/5.0/day2/4. Understsanding-Christ.png";
import prison from "../../images/5.0/day2/5. prison.png";
import typologies from "../../images/5.0/day2/6. Typologies.png";
import understanding from "../../images/5.0/day2/7. Understanding.png";
import understanding2 from "../../images/5.0/day2/8. Understanding.png";
import acceptable from "../../images/5.0/day2/9. Acceptable.png";
import exegesis from "../../images/5.0/day2/10. Exegesis.png";
import allegory from "../../images/5.0/day2/11. Allegory.png";

export default function DayTwo() {
  return (
    <>
      <Box>
        <Topic>The Good and the Acceptable Will</Topic>
        <Text>Romans 12:1-2, Isaiah 61:1-3, Luke 4:18</Text>
        <br />
      </Box>

      {/* Cover Image */}
      <Picture src={cover} />

      <Section>
        {/* Section 1: Introduction */}
        <Section>
          <Title>1. Introduction</Title>
          <Content>
            In the last session, we began to excavate His beautiful will and to
            see its divisions. A broad overview shows that it is divided into
            good, acceptable, and perfect. We also saw from the exegesis of{" "}
            <b>Isaiah 61:1-3a</b> that the will of the Lord is good and
            acceptable, while the will of God is perfect. In this lesson, we
            will further our journey into the volume of His will, and it is our
            prayer that the will of the Lord will be made manifest to every
            heart.
          </Content>
        </Section>

        {/* Section 2: Jesus, the Minister of the Will */}
        <Section>
          <Title>2. Jesus, the Minister of the Will</Title>
          <Picture src={jesus} />
          <Italics>
            "The Spirit of the Lord GOD is upon me; because the LORD hath
            anointed me to preach good tidings unto the meek; he hath sent me to
            bind up the brokenhearted, to proclaim liberty to the captives, and
            the opening of the prison to them that are bound; to proclaim the
            acceptable year of the LORD, and the day of vengeance of our God; to
            comfort all that mourn;" — Isaiah 61:1-2
          </Italics>
          <Content>
            Isaiah 61:1-2 is a Messianic prophecy which describes our Lord Jesus
            Christ. This prophecy describes the gradual and progressive
            administration of the will of God to men. This prophecy of scripture
            shows us that the work of the Messiah is not limited to dying for
            the sins of mankind on the cross alone <b>(Isaiah 53)</b>, but also
            includes the administration of all the will of God to a people. To
            accomplish this, Our Lord Jesus was born as a babe and obeyed all
            the will of God, being fashioned into the man of the will and the
            kingdom <b>(John 4:34, Matt 3:17)</b>. Following this, he was
            anointed to administer the will to mankind. It is our Lord Jesus
            that carries the Spirit of the Lord God. However, in administering
            the will, he first administers the will of the Lord, then, after
            which he administers the will of God. Let's also mention that our
            Lord Jesus uses men or ministry gifts in the administration of the
            will of God to the saints. A good example of such a man is Paul{" "}
            <b>(Eph 1:1, 4:10-13)</b>.
          </Content>
        </Section>

        {/* Section 3: The Will of the Lord makes you good and acceptable */}
        <Section>
          <Title>3. The Will of the Lord Makes You Good and Acceptable</Title>
          <Picture src={will} />
          <Italics>
            "The Spirit of the Lord is upon me, Because he hath anointed me to
            preach the gospel to the poor; He hath sent me to heal the
            brokenhearted, to preach deliverance to the captives, And recovering
            of sight to the blind, To set at liberty them that are bruised," —
            Luke 4:18
          </Italics>
          <Content>
            Our anchor texts for this study are <b>Isaiah 61:1-2</b> and{" "}
            <b>Luke 4:18</b>, which clearly describe the manifestation of the
            administration of the will of the Lord. Recall that the will of the
            Lord is good and acceptable. Hence, doing the will of the Lord makes
            the believer good and acceptable, granting the believer access into
            righteousness and peace, which is the dominion of the Lord. The
            kingdom stature corresponding to the will of the Lord is Christ.
            Clearly from the scriptures, we can easily observe that while the
            "good will" ultimately delivers the believer from the prison, the
            "acceptable will" makes the believer acceptable to God. Thus, it is
            one thing to be good in the sight of God and yet another to be
            acceptable <b>(1 Tim 2:3)</b>.
          </Content>
          <Content>
            Interestingly, we can further break down the good and acceptable
            will of the Lord for more clarity. Since the will of the Lord grants
            the believer access into the kingdom of Christ, then some insight
            concerning Christ can help simplify the content of the good and
            acceptable will.
          </Content>
        </Section>

        {/* Section 4: Understanding Christ */}
        <Section>
          <Title>4. Understanding Christ</Title>
          <Picture src={understandingChrist} />
          <SubSection>
            <Content>
              <Subtitle>A. The Jewish Understanding of Christ</Subtitle>
              "Christ" is a concept that was not strange to the Jews. In fact,
              the Jews were earnestly anticipating the coming of Christ{" "}
              <b>(John 1:19-21)</b>. However, they only understood Christ as a
              functional or dutiful word and not as the formation of a stature.
              To the mind of the average Jew, the Christ (anointed one) was a
              man who was to deliver them from the hand of their oppressors;
              hence, the interpretation <b>"Messiah"</b>, which is the deliverer{" "}
              <b>(John 1:41, 4:25)</b>. For example, men such as Moses, Gideon,
              Samson, Deborah, and many others were some type of christs in
              their own timelines <b>(Isa. 45:1)</b>. However, there remained
              the promise of "the Christ", who ought to bring a final end to all
              the oppressions of the Jews forever!{" "}
              <b>(Isaiah 9:6-7, Deut. 18:15)</b>. While the Jews expected a
              messiah who would deliver them from physical oppression, they were
              oblivious to the spiritual oppression of Sin, which all mankind
              had been subject to since Adam <b>(Rom 5:12, 3:9-12)</b>. Hence,
              the reason they didn't receive "the Christ" when he finally came.
              They were unable to discern the manner of deliverance because they
              misunderstood their bondage <b>(John 8:31-34)</b>.
            </Content>
            <Content>
              In sum, the Jews misunderstood two key things in being able to
              define Christ properly. First, Christ was only a duty, or
              responsibility, or an office and not a formation. Second, the
              deliverance was from physical oppression.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>B. Paul's Understanding of Christ</Subtitle>
              Paul, without any form of doubt, proclaimed that the mystery of
              Christ was committed to him by revelation{" "}
              <b>(Eph 3:1-5, 1 Cor. 9:17, 1 Tim. 1:11)</b>. This means that
              Paul, unlike other Jews, had the accurate understanding of the
              word "Christ". This is because Jesus said that Christ could be
              known only by revelation from the Father <b>(Matt. 16:16-17)</b>.
              In his epistles, Paul consistently describes Christ not just as a
              dutiful word, but as a stature that can be formed in the soul{" "}
              <b>(Eph. 3:17, Gal. 4:19)</b>. Hence, while the Jews understood
              Christ as an outward experience, Paul describes Christ as an
              inward experience <b>(Eph 3:16)</b>. Interestingly, the Apostle
              John also described the anointing (Christ) beyond an experience
              upon, but much more, an experience within <b>(1 John 2:27)</b>.
            </Content>
            <Content>
              Moreover, Paul evidently declares that Christ, by his law,
              delivers the soul from the law of sin and death <b>(Rom. 8:2)</b>,
              as against deliverance from physical oppression. Furthermore, Paul
              describes Christ as a <b>"spiritual rock" (1 Cor. 10:1-4)</b>,
              showing that Christ, as a stone, is a constitution that abides.
              Also, in <b>Isaiah 28:16</b>, Paul describes Christ as the stone,
              the tried stone, and the precious corner stone, which is the
              foundation of God <b>(1 Cor 3:10-11)</b>. Finally, Paul further
              describes Christ in three progressions:{" "}
              <b>Faith, Hope, and Charity (1 Cor. 13:13)</b>. Putting all these
              together, we can see that Christ is a nature that can be formed in
              a man. This nature is spiritual <b>(1 Cor 10:3-4)</b>. This
              nature, as a stone, is such that it abides as against what fades
              away <b>(1 Pet 1:24)</b>. This nature is fully described as Faith,
              Hope, and Charity. Finally, the nature is such that it delivers a
              soul from sin and death. Comparing scriptures, we can say that
              Christ is God's foundation that is a stone (faith), a tried stone
              (hope), and a precious corner stone (charity).
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>C. Christ is also Faith and Love</Subtitle>
              Paul, speaking to Timothy, mentions that Faith and Love are in
              Christ <b>(2 Tim. 1:13)</b>. One might ask, what about hope?
              Interestingly, Faith and Hope are similar because it is the trial
              of faith that worketh the patience of hope{" "}
              <b>(James 1:3, 1 Thess. 1:3)</b>. Hence, we can describe hope as
              faith that has been tried. This way, we can put in faith and hope
              as Faith. Thus, Christ can be described as Faith (faith and hope)
              and Love. Furthermore, in the context of righteousness and peace,
              while Faith works righteousness, Love works Peace{" "}
              <b>(Rom. 1:16-17, 2 Tim. 2:22)</b>. In addition, since we compared
              righteousness and peace to good and acceptable, we can conclude
              that the Good will is faith and hope, while the acceptable is
              charity.
            </Content>
          </SubSection>
        </Section>

        {/* Section 5 (labeled 4 in PDF): The World is a Prison */}
        <Section>
          <Title>5. The World is a Prison</Title>
          <Picture src={prison} />
          <Italics>
            "The Spirit of the Lord GOD is upon me; because the LORD hath
            anointed me to preach good tidings unto the meek; he hath sent me to
            bind up the brokenhearted, to proclaim liberty to the captives, and
            the opening of the prison to them that are bound;" — Isaiah 61:1
          </Italics>
          <Italics>
            "that made the world as a wilderness, and destroyed the cities
            thereof; that opened not the house of his prisoners?" — Isaiah 14:17
          </Italics>
          <Content>
            As was mentioned earlier, the culmination of the good will of the
            Lord is to deliver the prisoners from their prison. What is this
            prison? It is good to know that this present world was designed by
            Satan to imprison the souls of men. The world, as we often describe
            it, is a system. It is an expression of a wisdom that governs a
            lifestyle. This system is also such that it can fashion souls into
            its image, which is called flesh or the old man{" "}
            <b>(Rom. 12:2, Eph. 2:1–3, Eph 4:22)</b>. The Old Man is the
            formation in the soul after this fashioning. We can safely say that
            the world is Satan's system to imprison the souls of men through
            lusts and affections. There is a similarity between lust and will{" "}
            <b>(1 Peter 4:1-2)</b>. The lust of the world is the will of the
            world. This means that, just as the will transforms the soul, the
            lusts of this world also transform the soul until it becomes worldly
            and ungodly. Let us note that the world's system of life is built on
            the principles of the lust of the flesh, lust of the eyes and the
            pride of life <b>(1 John 2:15-17)</b>:
          </Content>
          <SubSection>
            <Content>
              <Subtitle>A. The Lust of the Flesh</Subtitle>
              The lust of the flesh is the desire and pursuit of earthly and
              physical vanities such as food, drink, clothes, shelter, cars,
              money, etc. This causes a man to summarise life as the acquisition
              of physical things <b>(Matt 6:25-34)</b>. This lust concludes and
              defines life in visible vanities <b>(Luke 12:15-19)</b> and
              empowers a man to have satisfaction in them. This is a wisdom of
              the world that ties a soul to the earth and begins the process of
              making one carnal. This is the first level of lust and worldliness
              in the soul.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>B. The Lust of the Eyes</Subtitle>
              The lust of the eyes is the desire and ambition for invisible
              earthly vanity, such as a name, influence, and reputation, giving
              the soul a kind of vision to perceive realities the natural man
              does not readily see, such as gain, power, and fame{" "}
              <b>(Acts 4:36–37; 5:1–3; John 12:43)</b>. The lust of the eyes
              empowers the soul to behold the glories of this world — visions of
              greatness, influence, and reputation. A good way to imagine this
              is when scriptures say that a "good name is better than riches"{" "}
              <b>(Prov 22:1)</b>. Lust of the eyes is the desire for a good
              name, while riches is the lust of the flesh.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>C. The Pride of Life</Subtitle>
              The pride of life is a sinful expression of life that expresses
              dominion through the glories shaped by worldly lusts. It is the
              state of a man who has attained the self-image projected through
              the worldly lusts and has come to rest in that identity apart from
              God. The pride of life brings a man to trust in his acquisitions,
              whether gained through the lust of the flesh or the lust of the
              eyes, and to find rest in his own labour, like the rich fool{" "}
              <b>(Luke 12:13-21)</b>. Such a man cannot be subject to the law of
              God and, by nature, becomes an enemy of God <b>(Romans 8:5-7)</b>.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>D. Works of the Flesh</Subtitle>
              Works of the flesh are the external or observable works of sin
              that may manifest in the life of those who have been or are being
              conformed to the world through worldly lusts or ungodliness. Works
              of the flesh are described in <b>Galatians 5:19-21</b>. They are
              works produced from a soul that is flesh. Let's mention here that
              flesh is beyond its works or deeds. Flesh is actually observed in
              his lusts and affections <b>(Gal 5:24)</b>. While flesh is a
              stature or a tree, his works are its fruits. Many a time, we
              conclude sin as the works of the flesh alone, but the lust and
              affections of the flesh are the real strength of the flesh.
            </Content>
          </SubSection>
          <Content>
            While lusts of the flesh and eyes make the soul worldly, pride of
            life makes the soul ungodly. There are good examples in scripture,
            particularly in the days of Jesus, of manners of men produced by
            these laws or principles in the world:
          </Content>
          <SubSection>
            <Content>
              <Subtitle>a. Sinners</Subtitle>
              These were men and women who had been ridden by the works of the
              flesh. They were the prostitutes, drunks, winebibbers, etc of the
              world. A good example was Mary Magdalene <b>(Luke 8:2)</b>.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>b. Publicans</Subtitle>
              These were men who had been fashioned by the lusts of the flesh
              because they were fulfilling the desire for visible vanities like
              money. They were the tax collectors and soldiers of their day. A
              good example was Zacchaeus <b>(Luke 19:1-10)</b>.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>c. Pharisees, Sadducees, and Scribes</Subtitle>
              These were men who were fashioned by the lust of the eyes, and
              some had already even become ungodly men. They were the religious
              leaders of their days and they were the ones who rejected the
              counsel of Jesus because of their love for glories{" "}
              <b>(Matt 23:1-12)</b>. It is good to mention here that these men
              did not have obvious works of the flesh, but were the worst of
              their day.
            </Content>
          </SubSection>
          <Content>
            Interestingly, it was easier to save the publicans and harlots than
            it was to save the scribes, Pharisees, and Sadducees{" "}
            <b>(Matt 21:31-32)</b>. This was a sign that the things of the world
            are also gradual and progressive in their strengths, and the goal of
            the world is to make a soul ungodly. It is also good to renew our
            minds on what we emphasise as grievous sins because it was the
            religious people who rejected salvation. While works of the flesh
            are wrong and should not be found or named among saints, there are
            more serious sins, such as worldly lusts and ungodliness.
          </Content>
        </Section>

        {/* Section 6: Typologies of the world as a prison */}
        <Section>
          <Title>6. Typologies of the World as a Prison</Title>
          <Picture src={typologies} />
          <Content>
            Interestingly, in scripture, we find two major types of bondage that
            the Israelites experienced, among many. The first major bondage was
            Egypt, while the second was Babylon. These two bondages give us some
            insight into the world as a prison and even reveal the difference in
            prison wardens, who are demons and evil spirits. Demons and evil
            spirits manage the prison for the devil to ensure there is no true
            deliverance!
          </Content>
          <SubSection>
            <Content>
              <Subtitle>A. Egypt: Land of Bondage</Subtitle>
              The Jews were under the bondage of Egypt for 400 years, and the
              Egyptians were hard taskmasters. This can be likened to the
              oppressive realm of the world managed by devils or demons
              (serpents and scorpions). Some examples: They oppress men by
              afflicting the body with sickness and disease; the mind with
              depression and suicidal thoughts. Israel was delivered from Egypt
              by the passover, which is likened to the death of our Lord on
              passover and brought about the New Birth. Just by being born
              again, a believer is free from Egypt <b>(Mark 16:15)</b>. The
              Israelites cried out to God for deliverance, and when they left
              Egypt, they all left.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>B. Babylon: Land of Captivity</Subtitle>
              Unlike Egypt, Babylon was a civilisation that allowed for the
              pursuit of one's dreams; for example, Daniel and his brethren were
              high officials. This captivated the Jews. Babylon is the realm of
              the world managed by princes such as principalities, powers, and
              rulers of the darkness of this world <b>(Eph. 6:12)</b>.
              Interestingly, it was only Daniel who sought deliverance, and it
              was by understanding books and knowledge <b>(Dan. 9:2-3)</b> and
              when they left, not all of Israel left. What sets the soul free
              from Babylon is the good will of the Lord. It was a birth that set
              the soul from Egypt; it is also a birth that will set the soul
              free from Babylon. This is why Jesus spoke of the new birth in{" "}
              <b>John 3:3</b> and of being born of the water and the Spirit in{" "}
              <b>John 3:5-7</b>. The first birth sets the soul free from Egypt;
              the second, from Babylon.
            </Content>
          </SubSection>
        </Section>

        {/* Section 7: Understanding the problem */}
        <Section>
          <Title>7. Understanding the Problem</Title>

          <Picture src={understanding} />
          <Italics>
            "The Spirit of the Lord is upon me, Because he hath anointed me to
            preach the gospel to the poor; He hath sent me to heal the
            brokenhearted, to preach deliverance to the captives, And recovering
            of sight to the blind, To set at liberty them that are bruised," —
            Luke 4:18
          </Italics>
          <Italics>
            "The Spirit of the Lord GOD is upon me; because the LORD hath
            anointed me to preach good tidings unto the meek; he hath sent me to
            bind up the brokenhearted, to proclaim liberty to the captives, and
            the opening of the prison to them that are bound;" — Isaiah 61:1
          </Italics>
          <Content>
            The Lord, in quoting Isaiah's prophecy <b>(Isa. 61:1-3a)</b>, shows
            us how the enemy holds us bound. First, every soul is held in
            prison, bound in chains, and is blind.
          </Content>
          <SubSection>
            <Content>
              <Subtitle>A. Blind</Subtitle>
              Blindness refers to the darkening of the eyes of our understanding{" "}
              <b>(Eph. 4:17-18)</b>.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>B. In Chains or Bands</Subtitle>A soul is in chains or
              bands when it becomes entangled and tied to the earth through vain
              desire for visible things. This captivity is actually the Lust of
              the Flesh, which is a life driven by an affinity for visible
              vanity <b>(Psa. 119:25)</b>.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>C. In Prison</Subtitle>
              What holds in prison is hope <b>(Zech 9:12)</b>; a man is a
              prisoner of his dreams and affections, and what fuels this is the
              Lust of the Eyes. This is the desire and ambition for invisible
              earthly vanity, such as a name, influence, or reputation. Hope is
              also described as an anchor <b>(Heb 6:19)</b>.
            </Content>
          </SubSection>
        </Section>

        {/* Section 8: Understanding the Progression of Deliverance */}
        <Section>
          <Title>
            8. Understanding the Progression of Our Deliverance from the World
          </Title>
          <Picture src={understanding2} />
          <Italics>
            "The Spirit of the Lord is upon me, Because he hath anointed me to
            preach the gospel to the poor; He hath sent me to heal the
            brokenhearted, to preach deliverance to the captives, And recovering
            of sight to the blind, To set at liberty them that are bruised," —
            Luke 4:18
          </Italics>
          <Italics>
            "The Spirit of the Lord GOD is upon me; because the LORD hath
            anointed me to preach good tidings unto the meek; he hath sent me to
            bind up the brokenhearted, to proclaim liberty to the captives, and
            the opening of the prison to them that are bound;" — Isaiah 61:1
          </Italics>
          <Content>
            It is good to know that when a soul has been made poor through
            weaning from the milk, deliverance then begins. The Lord, in quoting
            Isaiah's prophecy <b>(Isa. 61:1-3a)</b>, shows us how the enemy
            holds us bound. First, every soul is held in prison, bound in
            chains, and is blind. It means then that deliverance must occur in
            this same pattern. We see this pattern in the deliverance of Peter
            from prison <b>(Acts 12:5-10)</b>, in Samson's capture and death,
            and in Lazarus' raising.
          </Content>
          <SubSection>
            <Content>
              <Subtitle>Recovery of Sight to the Blind</Subtitle>
              It is light or knowledge that brings recovery of sight to the
              blind. This is described in the scriptures as the opening or
              enlightening of the eyes of the understanding{" "}
              <b>(Eph. 1:17-18, Psa. 18:28, 2 Sam. 22:29)</b>, and this light
              comes by the spirit of wisdom and understanding through the
              knowledge of him or his will.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>Proclaim Liberty to the Captives</Subtitle>
              It takes faith to annihilate the lust of the flesh because the
              lust of the flesh is a negative faith. Dealing with this lust will
              require turning the soul from the power of the visible. The hold
              or bands of vanity have to be broken by the preaching of the
              righteousness of Faith <b>(Heb. 11:1, 7-9, 2 Cor. 5:7)</b>.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>Opening of Prison to Them That Are Bound</Subtitle>
              After liberty has been proclaimed to the captive, such one now
              needs to be brought out of their prison. This prison house is the
              world, and being delivered from it is to be delivered from worldly
              lusts that make a soul become a prisoner of hope. It is by the
              leading of the spirit that these hopes and dreams are revealed
              because they are so ingrained in us that we do not know them{" "}
              <b>(Eph 4:22)</b>.
            </Content>
          </SubSection>
        </Section>

        {/* Section 9: The Acceptable Will */}
        <Section>
          <Title>9. The Acceptable Will</Title>
          <Picture src={acceptable} />
          <Content>
            The word "acceptable" is a relative word. It's relative, such that
            it is towards another. The acceptable will of the Lord is intended
            to make the good soul fit enough to transition to a higher dealing
            of God. While the good will is relative to the world, the acceptable
            will is relative to God. The good will brings the soul out of the
            world, while the acceptable will espouses the soul to God.
          </Content>
          <SubSection>
            <Content>
              <Subtitle>To Preach the Acceptable Year of the Lord</Subtitle>
              Clearly in <b>Isaiah 61:1-2</b>, we can see that after escape from
              the prison of the world, the acceptable will is intended to make
              the soul acceptable to God. Recall that while the good will makes
              the soul good, the acceptable should make the soul acceptable in
              the sight of God. Acceptability connotes a state of being at peace
              with God. Such a soul is no longer wrestling with God and has
              finally found rest from the world. Jesus said in <b>Matt 11:28</b>{" "}
              come into me, all ye that labour and are heavy laden, and I will
              give you rest. To be in labour and laden is to be a prisoner and
              captive <b>(Lam 5:5)</b>. After deliverance from the prison, there
              is a working of rest or peace that the Lord will also give{" "}
              <b>(John 14:27)</b>. In the epistles, Paul consistently links this
              state of peace to a conversation called charity or love. This love
              is not just the initial love unto all saints as we saw in the
              milk, but a love that is out of a pure heart{" "}
              <b>(2 Tim 2:22, 1 Pet 1:22, 1 Tim 1:5, Col 3:14-15)</b>.
            </Content>
          </SubSection>
        </Section>

        {/* Section 10: Exegesis of Faith, Hope, and Love */}
        <Section>
          <Title>10. Exegesis of Faith, Hope, and Love</Title>
          <Picture src={exegesis} />
          <SubSection>
            <Content>
              <Subtitle>A. What is Faith?</Subtitle>
              Faith is basically the substance of things hoped for and the
              evidence of the unseen <b>(2 Cor 4:18)</b>. Hence, Faith begins
              with the ability to see (by understanding) the realm of the
              kingdom, or the hope of his calling in the invisible{" "}
              <b>(John 3:3, Eph 1:16-17, Heb 11:7, 8, 27, Matt 6:33)</b>. Faith
              goes on to instruct the soul both objectively and subjectively to
              detach from visible realities that keep the soul bound to the
              earth or carnal. These instructions are the revelation of the
              righteousness of God <b>(Rom 1:16)</b>. Thus, righteousness are
              obediences that delivers the soul from the lusts of the flesh.
              Such a soul is said to be walking by faith in response to the
              invisible. Some examples of Faith obediences in scripture are Noah{" "}
              <b>(Heb 11:7)</b>, Abraham <b>(Heb 11:8)</b>, Moses{" "}
              <b>(Heb 11:27)</b>, etc.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>B. What is Hope?</Subtitle>
              Hope is born when faith is tried <b>(James 1:3, 1 Thess 1:3)</b>.
              Hope confronts the invisible desires of the soul for glories in
              the world. These bring the soul out of the world. This is such
              that the believer is resolved to live in the kingdom alone despite
              all of the contradictions of faith. This is where shame is
              completely dealt with. At this point, the believer is no longer
              ashamed because hope makes not ashamed{" "}
              <b>(Rom 5:3-5, Rom 1:16)</b>. To escape from prison is to be
              delivered from the hopes of this world. The training of hope
              purifies the soul and makes the heart pure{" "}
              <b>(1 John 3:3, Matt 5:8, 1 Pet 1:22)</b>. At this point, the
              believer is said to be good or righteous.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>C. What is Charity?</Subtitle>
              Charity is a life of freedom from worldliness <b>(Gal 5:13)</b>.
              It is to learn to love with a pure heart <b>(1 Tim 1:5)</b>. This
              is because hope purifies the soul from desire for glories or lust
              of the eyes. A man of charity loves brethren and also desires to
              be accepted into the things of God <b>(1 Pet 1:22)</b>. Here, the
              soul is also trained to deny ungodliness, which is seeing oneself
              as better than others <b>(Phil 2:3-4, Romans 12:16, Gal 5:26)</b>.
              It's judging the tendencies of being high-minded by lowliness or
              becoming nothing. A charitable man is he who is acceptable to God.
              A good description of the man that is acceptable to God is in{" "}
              <b>1 Corinthians 13:7-11</b>. However, such a man must wait for a
              season called the accepted time, which is the season of entrance
              into the world of the kingdom of God or Joy or Perfection{" "}
              <b>(2 Cor 6:2)</b>. A typology of this can be seen in the story of
              Cain and Abel <b>(Gen 4:1-7)</b>.
            </Content>
          </SubSection>
        </Section>

        {/* Section 11: An Allegory of the Good and the Acceptable */}
        <Section>
          <Title>11. An Allegory of the Good and the Acceptable</Title>
          <Picture src={allegory} />
          <Italics>
            Wherefore come out from among them, and be ye separate, saith the
            Lord, and touch not the unclean thing; and I will receive you. — 2
            Corinthians 6:17
          </Italics>
          <Content>
            This portion of Scripture highlights, from another perspective, the
            seasons of the will of Christ that qualify a believer to be
            acceptable to God.
          </Content>
          <SubSection>
            <Content>
              <Subtitle>To come out from among them</Subtitle>
              …is to undergo the training of the faith of Christ and begin a
              journey away from the world and its lusts <b>(Hebrews 11:8)</b>.
              The believer is persuaded of an unseen hope, which is contrary to
              the pursuits of the Gentiles, and commits to a life of obedience
              in response to that which is not seen{" "}
              <b>(Ephesians 4:17; Hebrews 11:13)</b>. While the life of the
              Gentiles is governed by the visible — what to eat, what to drink,
              and what to wear — the believer embraces a separated life, turning
              from the pursuit of visible things to living for the unseen, and
              is thereby launched into the realm of the unseen through the faith
              of the Son of God{" "}
              <b>
                (Matthew 6:25, 32; 2 Corinthians 4:18; 2 Corinthians 5:7;
                Galatians 2:20)
              </b>
              .
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>To be separate</Subtitle>
              …is to further commit oneself to a life that is free from worldly
              lusts by detaching from the pursuit of invisible vanities. In this
              season, the believer embraces the hope much more as against the
              desire for the glories of the world <b>(Romans 4:18)</b>. This
              commandment of being separate is kept in the season of hope; by so
              doing, one fulfils the good will of God <b>(Romans 12:2)</b>.
            </Content>
          </SubSection>
          <SubSection>
            <Content>
              <Subtitle>To touch not the unclean</Subtitle>
              …is to be made totally free from ungodliness, which itself is the
              unclean <b>(Titus 2:11)</b>. This reflects the training that takes
              place in the season of charity, where the believer, through the
              gospel of Christ, learns not to be lifted up in heart by either
              spiritual or physical attainments <b>(Psalm 24:4)</b>. He learns
              not to take pride in his abilities or achievements, but to regard
              himself as the least among his brethren{" "}
              <b>
                (Galatians 5:26; Ephesians 3:8; Romans 12:10; Philippians 2:3)
              </b>
              . Counting all other glories as nothingness, he will perpetually
              and solely long for the fullness of God — the only true glory he
              esteems <b>(1 Corinthians 13:2-3; Psalm 42:2; Psalm 3:3)</b>. This
              is a complete severance from every trace of ungodliness and pride,
              thereby becoming free from the corruption that is in the world{" "}
              <b>(2 Peter 1:4; 2 Peter 2:20)</b>. This exercise makes a believer
              not only clean but also acceptable in the sight of God; hence the
              last phrase of the verse —{" "}
              <b>
                I will receive you (Romans 12:2; 1 Peter 2:25; 2 Corinthians
                6:17)
              </b>
              .
            </Content>
          </SubSection>
        </Section>
      </Section>

      {/* Conclusion */}
      <Section>
        <SubSection>
          <Title>12. Conclusion</Title>
          <Content>
            We have seen from today's lesson what the will of the Lord is (Good
            and Acceptable), its principles (Faith, Hope, and Charity) and how
            it delivers us from the prison of this world, from the captivity of
            lust of the flesh, and that process is kick-started by the recovery
            of sight through the opening of the eyes of our understanding.
          </Content>
        </SubSection>
      </Section>

      <WithLove />
    </>
  );
}
